import './index.css'
import RedesSociales from './RedesSociales/RedesSociales';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useWindowSize } from '@utils/resize';
import { useState, useEffect } from 'react';
export default function Contacto() {
    const { width } = useWindowSize();
    const [links, setLinks] = useState<{ name: string, link: string, active: boolean }[]>([])

    useEffect(() => {
        // Cargar el config.json desde la carpeta public
        const loadConfig = async () => {
            try {
                const response = await fetch('/config.json');
                const config = await response.json();
                setLinks(config.LINKS)
            } catch (error) {
                console.error('Error loading config:', error);
            }
        };

        loadConfig();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div className="contacto">
            <RedesSociales />
            {width > 1300 && links.length > 0 &&
                <div className='contacto-container'>
                    {links[0].active &&
                        <a className='link' href={links[0].link}>
                            <LocationOnIcon sx={{ color: 'white', width: '15px' }} />
                            <span className='link-descripcion'>{links[0].name}</span>
                        </a>
                    }
                    {links[1].active &&
                        <a className='link' href={links[1].link}>
                            <LocalPhoneIcon sx={{ color: 'white', width: '15px' }} />
                            <span className='link-descripcion'>{links[1].name}</span>
                        </a>
                    }
                    {links[2].active &&
                        <a className='link' href={links[2].link}>
                            <MailOutlineIcon sx={{ color: 'white', width: '15px' }} />
                            <span className='link-descripcion'>{links[2].name}</span>
                        </a>
                    }
                    {links[3].active &&
                        <a className='link' href={links[3].link}>
                            <MailOutlineIcon sx={{ color: 'white', width: '15px' }} />
                            <span className='link-descripcion'>{links[3].name}</span>
                        </a>
                    }
                    {links[4].active &&
                        <a className='link' href={links[4].link}>
                            <MailOutlineIcon sx={{ color: 'white', width: '15px' }} />
                            <span className='link-descripcion'>{links[4].name}</span>
                        </a>}
                </div>
            }

        </div>
    );
}